import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SegmentedControl } from '@feathr/components';

export type TProjectStatus = 'active' | 'archived';

interface IProjectStatusSegmentedControlProps {
  value: TProjectStatus;
  onChange: (status: TProjectStatus) => void;
  activeCount?: number;
  archivedCount?: number;
  fullWidth?: boolean;
}

function ProjectStatusSegmentedControl({
  value,
  onChange,
  activeCount,
  archivedCount,
  fullWidth = true,
}: Readonly<IProjectStatusSegmentedControlProps>): JSX.Element {
  const { t } = useTranslation();

  function handleChange(newValue: string): void {
    onChange(newValue as TProjectStatus);
  }

  const data = [
    {
      label: t('Active'),
      value: 'active',
      count: activeCount ?? 0,
    },
    {
      label: t('Archived'),
      value: 'archived',
      count: archivedCount ?? 0,
    },
  ];

  return (
    <SegmentedControl
      data={data}
      fullWidth={fullWidth}
      name={'project-status-segmented-control'}
      onChange={handleChange}
      value={value}
    />
  );
}

export default ProjectStatusSegmentedControl;
